import { TransactionType } from 'src/interfaces/banking';

import { ActionTabDefaults } from '../ActionTab/ActionTab.interfaces';

export const swapActionTabDefaultValues: ActionTabDefaults = {
  titleKey: 'banking.actions.swap.title',
  descriptionKey: 'banking.actions.swap.description',
  type: TransactionType.Swap
};
